import { baseApi } from '../baseApi';
import { FeedbackRequestData } from './types';

const feedbackApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    sendFeedback: build.mutation<void, FeedbackRequestData>({
      query: ({
        name,
        email,
        desiredMonthlyTrackGenerations,
        additionalInformation,
      }) => {
        const formData = new FormData();

        formData.set('name', name.trim());
        formData.set('email', email.trim());
        formData.set(
          'desiredMonthlyTrackGenerations',
          desiredMonthlyTrackGenerations.trim()
        );
        formData.set('additionalInformation', additionalInformation.trim());

        return {
          url: '/feedback',
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export default feedbackApi;
